import { useRouter } from 'next/router'
import { PropsWithChildren, ReactElement, useEffect, useState } from 'react'
import { IWebMenu } from '../../interfaces/webMenu'
import ExtendedCard from './card/extendedCard.component'
import SimpleCard from './card/simpleCard.component'
import WaterMark from '../waterMark.component'

const createCardComponents = (webMenu: IWebMenu[]): ReactElement[] => {
  return webMenu.filter(item => item.visible).map((item: IWebMenu) => {
    const { id, isExtended = false } = item

    return isExtended ? (
      <ExtendedCard key={id} webmenu={item} />
    ) : (
      <SimpleCard key={id} webmenu={item} />
    )
  })
}

interface IMenu {
  activePage: IWebMenu
}

const shouldMenuBeVisible = (
  url_HU: string,
  url_EN: string,
  asPath: string
): boolean => url_HU === asPath.substring(0, asPath.indexOf('?') !== -1 ? asPath.indexOf('?') : asPath.length) || url_EN === asPath.substring(0, asPath.indexOf('?') !== -1 ? asPath.indexOf('?') : asPath.length)

const HomePageCardListWrapper: React.FC<PropsWithChildren> = ({ children }) => {
  return (
    <nav className='relative grid gap-desktop grid-cols-4 2xl:grid-cols-12 mt-0 xl:mt-[-25px] pt-6 xl:pt-6.25 pb-8 2xl:pb-22.5'>
      {children}
    </nav>
  )
}

const SubPageCardListWrapper: React.FC<PropsWithChildren> = ({ children }) => {
  return (
    <div className='relative grid gap-desktop grid-cols-4 2xl:grid-cols-12 pt-24 2xl:pt-6'>
      {children}
    </div>
  )
}

interface ICardListProps {
  childList: IWebMenu[]
  isHomePage: boolean
}

const CardList: React.FC<ICardListProps> = ({ childList, isHomePage }) => {
  return (
    <div className='z-2 col-start-1 col-span-4 2xl:col-start-3 2xl:col-span-8 md:mx-1/6 2xl:mx-0'>
      <div className='grid gap-desktop grid-cols-4 2xl:grid-cols-12'>
        {createCardComponents(childList)}
        {/* {isHomePage && (
          <div className='hidden h-card col-start-2 col-span-3 2xl:col-start-8 2xl:col-span-5 2xl:block'>
            <WaterMark transparent={false} isLarge={false} />
          </div>
        )} */}
      </div>
    </div>
  )
}

const Menu: React.FC<IMenu> = ({ activePage }) => {
  const { childList = [], url_HU, url_EN } = activePage
  const [isVisible, setIsVisible] = useState(false)
  const { pathname, asPath } = useRouter()
  const isHomePage = pathname === '/'

  useEffect(() => {
    setIsVisible(shouldMenuBeVisible(url_HU, url_EN, asPath))
  }, [asPath, url_EN, url_HU])
  return (
    <>
      {isVisible && (
        <>
          {isHomePage ? (
            <HomePageCardListWrapper>
              <CardList childList={childList} isHomePage={true} />
            </HomePageCardListWrapper>
          ) : (
            <SubPageCardListWrapper>
              <CardList childList={childList} isHomePage={false} />
            </SubPageCardListWrapper>
          )}
        </>
      )}
    </>
  )
}

export default Menu
